import { useIsMerchant } from './useIsMerchant';
import { useIsVendor } from './useIsVendor';

/**
 * True for a user with no merchant, vendor or facility entity of their own — a
 * platform admin, who acts for an organization only through the entity picker.
 * The services decide admin rights from roles; this only decides what the UI
 * offers and sends.
 */
export function useIsAdminEntity(): boolean {
  const isMerchant = useIsMerchant();
  const isVendor = useIsVendor();
  return !isMerchant && !isVendor;
}
